/*
 * Codici del clic degli annunci Google (gclid, gbraid, wbraid) nell'ordine, solo con il consenso
 * "Marketing" di iubenda (finalita' 5). Bozza 1.4.2, 4 ottobre 2026.
 *
 * Perche': iubenda non passa il consenso a Shopify, quindi Shopify non registra la pagina d'arrivo
 * con il gclid (0 ordini su 163 negli ultimi 4 mesi). Qui, se il visitatore ha accettato il
 * marketing, i codici si leggono dall'indirizzo, si tengono per la visita (sessionStorage) e si
 * scrivono negli attributi del carrello «gclid», «gbraid», «wbraid», che finiscono nell'ordine.
 *
 * Senza consenso non si legge e non si salva niente. Se il consenso arriva dopo l'atterraggio, i
 * codici si prendono solo se sono ancora nell'indirizzo della pagina. Se il marketing viene
 * rifiutato o revocato, quello che era stato salvato si cancella.
 */
(() => {
  const CHIAVI = ['gclid', 'gbraid', 'wbraid'];
  const MEMORIA = 'bg_clic_annunci';
  const ATTESA_MASSIMA = 120000;

  // true = marketing accettato, false = rifiutato, null = nessuna scelta (o iubenda non pronto)
  function consensoMarketing() {
    try {
      const scelte = window._iub && window._iub.cs && window._iub.cs.consent && window._iub.cs.consent.purposes;
      if (!scelte || !Object.keys(scelte).length) return null;
      return scelte['5'] === true;
    } catch (e) {
      return null;
    }
  }

  const leggiMemoria = () => {
    try {
      return JSON.parse(sessionStorage.getItem(MEMORIA) || '{}');
    } catch (e) {
      return {};
    }
  };

  async function aggiornaCarrello(valori) {
    try {
      const carrello = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const attuali = carrello.attributes || {};
      const daScrivere = {};
      for (const k of CHIAVI) {
        const v = valori[k] || '';
        if ((attuali[k] || '') !== v && (v || attuali[k])) daScrivere[k] = v;
      }
      if (!Object.keys(daScrivere).length) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: daScrivere }),
      });
    } catch (e) {
      /* il carrello non risponde: si riprova alla pagina dopo */
    }
  }

  function conConsenso() {
    const indirizzo = new URLSearchParams(location.search);
    const valori = leggiMemoria();
    for (const k of CHIAVI) {
      const v = indirizzo.get(k);
      if (v && /^[\w.-]{5,300}$/.test(v)) valori[k] = v;
    }
    if (!Object.keys(valori).length) return;
    try {
      sessionStorage.setItem(MEMORIA, JSON.stringify(valori));
    } catch (e) {
      /* senza sessionStorage vale solo questa pagina */
    }
    aggiornaCarrello(valori);
  }

  function senzaConsenso() {
    const salvati = leggiMemoria();
    try {
      sessionStorage.removeItem(MEMORIA);
    } catch (e) {}
    if (Object.keys(salvati).length) aggiornaCarrello({});
  }

  let ultimo = null;
  function controlla() {
    const c = consensoMarketing();
    if (c === ultimo) return c;
    ultimo = c;
    if (c === true) conConsenso();
    else if (c === false) senzaConsenso();
    return c;
  }

  function avvia() {
    controlla();
    // la scelta nel banner puo' arrivare dopo: si ricontrolla per un po', e quando si torna sulla pagina
    const inizio = Date.now();
    const giro = setInterval(() => {
      controlla();
      if (Date.now() - inizio > ATTESA_MASSIMA) clearInterval(giro);
    }, 1000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) controlla();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
